'use strict';

import type { UserIntegrationProvider } from '../../Entities/User/UserIntegrationProvider';
import { EntityCollection } from '../EntityCollection';

export class UserIntegrationProviderCollection extends EntityCollection<UserIntegrationProvider> {}
